import { Component, OnInit, computed, effect, inject, signal } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ActivableFilter, FiltersService } from '../../../services/filters.service';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  standalone: false
})
export class FiltersComponent implements OnInit {
  private filtersService = inject(FiltersService);
  private sheetRef = inject(MatBottomSheetRef<FiltersComponent>);

  filters = signal<ActivableFilter[]>([]);
  loading = computed(() => this.filtersService.loading());

  constructor() {
    effect(() => {
      this.filters.set(this.filtersService.allFilters().map(filter => ({ ...filter })));
    });
  }

  ngOnInit(): void {
    this.filtersService.setFilters();
  }

  toggleFilter(filter: ActivableFilter, isActive: boolean): void {
    this.filters.update(filters => filters.map(f => f.id === filter.id ? { ...f, isActive } : f));
  }

  confirm(): void {
    this.filtersService.updateFilters(this.filters());
    this.close();
  }

  clearSelections(): void {
    this.filters.update(filters => filters.map(filter => ({ ...filter, isActive: false })));
    this.filtersService.updateFilters(this.filters());
  }

  close(): void {
    this.sheetRef.dismiss();
  }
}
